import ResicoAPI from '@/api/resico';

const state = {
  products_list: [],
};

const mutations = {
  setResicoProducts(state, payload) {
    state.products_list = payload;
  },
};

const actions = {
  fetchProductsList(context) {
    return new Promise((resolve, reject) => {
      ResicoAPI.getProducts(context.rootState.cafe._id)
        .then((data) => {
          context.commit('setResicoProducts', data.products);
          resolve();
        })
        .catch((error) => {
          context.dispatch('showError', 'poster_error', {
            root: true,
          });
          reject();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
